import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=3bbf1d5b&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbf1d5b')) {
      api.createRecord('3bbf1d5b', component.options)
    } else {
      api.reload('3bbf1d5b', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=3bbf1d5b&", function () {
      api.rerender('3bbf1d5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4OfNen6H71g7H/JS/comp/stardisplay.vue"
export default component.exports